module.exports = __webpack_public_path__ + "static/media/icon-menu-down-end-active.32be3841.svg";